module.exports = __webpack_public_path__ + "/images/shop/footer/tec_alliance.jpg";